import React from 'react';
import ModernResumePersonalInformation from './ModernResumePersonalInformation';
import ModernResumeSummary from "./ModernResumeSummary";
import ModernResumeHobbies from "./ModernResumeHobbies";
import ModernResumeCustom from "./ModernResumeCustom";
import ModernResumeEmployment from './ModernResumeEmployment';
import ModernResumeEducation from "./ModernResumeEducation";
import ModernResumeReference from "./ModernResumeReference";
import ModernResumeSkills from "./ModernResumeSkills";
import ModernResumeLanguage from "./ModernResumeLanguage";

export default class ModernResume extends React.Component {
    getAllOtherParts(){
        let otherForms = []
        for(let i = 0; i < this.props.resumeData.otherForms.length; i++){
            let form = this.props.resumeData.otherForms[i];
            switch(form.type){
                     case 'summary':
                         otherForms.push(<ModernResumeSummary title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'hobbies':
                         otherForms.push(<ModernResumeHobbies title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'custom':
                         otherForms.push(<ModernResumeCustom title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'employment':
                         otherForms.push(<ModernResumeEmployment title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'education':
                         otherForms.push(<ModernResumeEducation title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'references':
                         otherForms.push(<ModernResumeReference title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'skills':
                         otherForms.push(<ModernResumeSkills title={form.title} data={form.data} key={i}/>);
                         break;
                     case 'languages':
  					     otherForms.push(<ModernResumeLanguage title={form.title} data={form.data} key={i}/>);
                default:
                // Do nothing;
            }
        }
        return otherForms;
    }
    render() { 
        return  <div data-v-37c786be="" className="container">
			
            <ModernResumePersonalInformation
                title={this.props.resumeData.personalDetailForm.title}
                data={this.props.resumeData.personalDetailForm.data}/>
				
				{this.getAllOtherParts()}
            
    </div>;
    }
}